import ax from '../axios'
import {API_URL} from '../index'

type ActivityId = string | number
export interface ActivityFile {id: ActivityId; name: string; mimeType: string; size: number}
export interface Activity {
  id: ActivityId
  name: string
  outcome: string
  category?: {id: ActivityId; name: string}
  theme?: {id: ActivityId; name: string}
  gradeLevel?: {id: ActivityId; title: string}
  learningArea?: {id: ActivityId; title: string}
  unit?: {id: ActivityId; title: string}
  storyIds: number[]
  files: ActivityFile[]
}
export interface ActivityPage {items: Activity[]; total: number; page: number; pageSize: number}
export interface ActivityFilters {
  categories: Array<{id: ActivityId; name: string}>
  themes: Array<{id: ActivityId; name: string}>
  gradeLevels: Array<{id: ActivityId; title: string}>
}
export interface ActivityQuery {page?: number; pageSize?: number; search?: string; categoryId?: string; themeId?: string; gradeLevelId?: string; storyId?: string}
const base = API_URL.EDUCATION_MODULE.replace(/\/$/, '') + '/activity/library'
async function get<T>(path: string, params?: ActivityQuery): Promise<T> {
  const result = await ax.get<any, {status: boolean; data: T}>(base + path, {params})
  if (!result.status) throw new Error('Etkinlik bilgileri alınamadı.')
  return result.data
}
export const activityApi = {
  list: (query: ActivityQuery) => get<ActivityPage>('', query),
  filters: () => get<ActivityFilters>('/filters'),
  detail: (id: string) => get<Activity>(`/${encodeURIComponent(id)}`),
  fileUrl: (activityId: ActivityId, fileId: ActivityId) => get<{url: string; expiresIn: number}>(`/${encodeURIComponent(activityId)}/files/${encodeURIComponent(fileId)}/url`),
}
